import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.REACT_APP_MY_HOST}/v7/admin/language`;
const FORWARD_API_URL = `${process.env.REACT_APP_FORWARD_HOST}/v7/admin/language`;
const FORWARD_API_URL_2 = `${process.env.REACT_APP_FORWARD_HOST3}/v7/admin/language`;
const PROPOSALS_URL = `${process.env.REACT_APP_MY_HOST}/v7/admin/language-proposals`;

class LanguageService {

    getLanguage(tool) {
        return axios.get(`${API_URL}?tool=${tool}`, { headers: authHeader() });
    }

    createLanguage(tool, key, vi, en) {
        return axios.post(`${API_URL}?tool=${tool}&key=${key}&vi=${vi}&en=${en}`, null, { headers: authHeader() });
    }

    createLanguageJson(tool, jsonData) {
        return axios.post(`${API_URL}-json?tool=${tool}`, jsonData, {
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            }
        });
    }

    updateLanguage(tool, id, key, vi, en) {
        return axios.post(`${API_URL}-update?tool=${tool}&id=${id}&key=${key}&vi=${vi}&en=${en}`, null, { headers: authHeader() });
    }

    deleteLanguage(tool, id, key) {
        return axios.post(`${API_URL}-delete?tool=${tool}&id=${id}&key=${key}`, null, { headers: authHeader() });
    }

    deleteListLanguage(tool, languageList) {
        return axios.post(`${API_URL}-delete-list?tool=${tool}`, languageList, {
            headers: {
                ...authHeader(),
                'Content-Type': 'application/json'
            }
        });
    }



    commitLanguage(tool) {
        const req1 = axios.get(`${FORWARD_API_URL}/commit?tool=${tool}`, { headers: authHeader() });
        const req2 = axios.get(`${API_URL}/commit?tool=${tool}`, { headers: authHeader() });
        const req3 = axios.get(`${FORWARD_API_URL_2}/commit?tool=${tool}`, { headers: authHeader() });
        
        return Promise.all([req1, req2, req3]);
    }

    // ========================================
    // LANGUAGE PROPOSALS
    // ========================================

    getProposals(tool, status, page = 1, limit = 200) {
        const params = new URLSearchParams();
        if (tool) params.append('tool', tool);
        if (status) params.append('status', status);
        params.append('page', page);
        params.append('limit', limit);
        return axios.get(`${PROPOSALS_URL}?${params}`, { headers: authHeader() });
    }

    getProposalStats(tool) {
        const params = tool ? `?tool=${tool}` : '';
        return axios.get(`${PROPOSALS_URL}/stats${params}`, { headers: authHeader() });
    }

    createProposal(proposals) {
        return axios.post(PROPOSALS_URL, proposals, { headers: { ...authHeader(), 'Content-Type': 'application/json' } });
    }

    updateProposal(id, data) {
        return axios.put(`${PROPOSALS_URL}/${id}`, data, { headers: { ...authHeader(), 'Content-Type': 'application/json' } });
    }

    deleteProposal(id) {
        return axios.delete(`${PROPOSALS_URL}/${id}`, { headers: authHeader() });
    }

    approveProposal(id, data = {}) {
        return axios.put(`${PROPOSALS_URL}/${id}/approve`, data, { headers: { ...authHeader(), 'Content-Type': 'application/json' } });
    }

    rejectProposal(id, data = {}) {
        return axios.put(`${PROPOSALS_URL}/${id}/reject`, data, { headers: { ...authHeader(), 'Content-Type': 'application/json' } });
    }

    bulkApproveProposals(ids) {
        return axios.post(`${PROPOSALS_URL}/bulk-approve`, { ids }, { headers: { ...authHeader(), 'Content-Type': 'application/json' } });
    }

    bulkRejectProposals(ids, reviewNote = '') {
        return axios.post(`${PROPOSALS_URL}/bulk-reject`, { ids, reviewNote }, { headers: { ...authHeader(), 'Content-Type': 'application/json' } });
    }
}

export default new LanguageService();

